import { getTenantSubdomain } from "./urls"

export const PLATFORM_ACCESS_TOKEN_KEY = "platform_access_token"

export function getPlatformAccessToken(): string {
  return localStorage.getItem(PLATFORM_ACCESS_TOKEN_KEY) || ""
}

export function setPlatformAccessToken(token: string) {
  localStorage.setItem(PLATFORM_ACCESS_TOKEN_KEY, token)
}

export function clearPlatformAccessToken() {
  localStorage.removeItem(PLATFORM_ACCESS_TOKEN_KEY)
}

export function isPlatformLoggedIn(): boolean {
  return getPlatformAccessToken() !== ""
}

export function isTenantSubdomainHost(): boolean {
  const subdomain = getTenantSubdomain()
  return subdomain !== null && subdomain !== "selfhosted"
}
